// Aktionsmodul: Interne Aufgabe erstellen. Kein Auto-Vorschlag (erzeugen() liefert
// immer null) — wird manuell im Aktions-Panel angelegt.
import { supabase } from '../../supabase/client';
import type { AktionEntwurf, AktionKontext, AktionModul, TicketAktion } from '../types';

export function erzeugen(_ctx: AktionKontext): AktionEntwurf | null {
  return null;
}

// Dünner Supabase-Wrapper (Konvention: nicht unit-getestet).
export async function ausfuehren(aktion: TicketAktion): Promise<{ ok: boolean; fehler?: string }> {
  const { error: kommentarError } = await supabase.from('ticket_kommentare').insert({
    ticket_id: aktion.ticket_id,
    autor_id: null,
    inhalt: `Aufgabe: ${aktion.entwurf_text ?? ''}`,
    ist_intern: true,
  });
  if (kommentarError) return { ok: false, fehler: kommentarError.message };

  const { error: historieError } = await supabase.from('ticket_historie').insert({
    ticket_id: aktion.ticket_id,
    benutzer_id: null,
    aktion: 'aufgabe_erstellt',
    neuer_wert: 'Interne Aufgabe erstellt',
  });
  if (historieError) return { ok: false, fehler: historieError.message };

  return { ok: true };
}

export const interneAufgabeModul: AktionModul = { typ: 'interne_aufgabe', erzeugen, ausfuehren };
